import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";
import {gsap} from "gsap"

export class DecadenceFSIntroPresentation extends SimplePresentation {

    constructor() {
        super("FreespinsIntroPresentation", false);
    }

    shouldRun(): boolean {
        return Decadence.model.mode == "NORMAL" && Decadence.model.nextMode.toString().includes("FREESPIN");
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() => {}, ">0.5");
        this.tl.eventCallback("onComplete", () => {});

        const isSuper = Decadence.model.nextMode == GameMode.FREESPIN_SUPER;

        const scatters = Decadence.reelView.getActiveSymbols().filter(s => s.name == "SC" || s.name == "SSC");
        tl.add(() => {
            Decadence.soundPlayer.playSound("scatterPump");
        })
        tl.add(scatters.map(s => s.playScatterActivate()));

        tl.add(<any>Decadence.keypadPlugin.hide(0));
        tl.add(Decadence.reelView.playMonsterWakeUp(), "<");
        tl.add(Decadence.backgroundElements.transitionMode(GameMode.FREESPIN), "<");
        tl.add(Decadence.transitionScreen.showFSIntro(isSuper), "<");
        tl.add(() => {
            Decadence.soundPlayer.playSound("fsIntroStart");
            Decadence.soundPlayer.fadeOutMusic();
            Decadence.soundPlayer.switchMusic("FS_INTRO");
            Decadence.soundPlayer.fadeInMusic();
        }, "<")
        tl.add(Decadence.transitionScreen.darken(0.2), "<");
        tl.add(Decadence.transitionScreen.enableButton(() => this.onButtonClicked()));
    }

    private onButtonClicked() {
        const tl = gsap.timeline();
        tl.add(() => {
            Decadence.keypadPlugin.setZeroBetSpinCounter(Decadence.model.data.freespinsLeft);
            Decadence.soundPlayer.switchMusic("FREESPIN");
        })
        tl.add(<any>Decadence.keypadPlugin.show(0.2));
        tl.add(Decadence.transitionScreen.hide(0.2), "<")
        tl.add(() => {
            this.controller.finish();
        })
        return tl;
    }
}
